module.exports = __webpack_public_path__ + "img/logo_Eglife1.bec21c23.png";